<template>
  <div class="cml-input-maxlength">
    <el-divider class="cml-divider" id="cml-divider" content-position="center">{{ statusName }}新产品</el-divider>
    <el-form
      :disabled="formDisabled"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="300px"
    >
      <el-form-item label="供应商" prop="supplierCode">
        <SupplierSelect
          supplierType="GIFT_MATERIAL"
          :value="formData.supplierCode"
          @change-emit="supplierChange"
          v-if="isEditSupplier"
        />
        <el-input
          disabled
          v-model="formData.supplierName"
          v-else
        />
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input disabled v-model.trim="formData.contactName"></el-input>
        <a
          href="https://syounggroup.feishu.cn/docx/LqoTdMq6CoWTwUxbxQXcN0kFnEf"
          target="_blank"
          style="margin-left: 10px; color: #AB0033; font-size: 12px;"
        >修改</a>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input disabled v-model.trim="formData.contactPhone"></el-input>
        <a
          href="https://syounggroup.feishu.cn/docx/LqoTdMq6CoWTwUxbxQXcN0kFnEf"
          target="_blank"
          style="margin-left: 10px; color: #AB0033; font-size: 12px;"
        >修改</a>
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model.trim="formData.productName"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="产品一级分类" prop="firstCategory">
        <DictSelect
          :disabled="status === 'update'"
          type="cml_pd_first_category"
          :value="formData.firstCategory"
          @change-emit="firstCategoryChange"
        />
      </el-form-item>
      <el-form-item label="产品二级分类" prop="secondCategory">
        <DictSelect
          :disabled="status === 'update'"
          :propData="secondCategoryList"
          :value="formData.secondCategory"
          @change-emit="secondCategoryChange"
        />
      </el-form-item>
      <el-form-item
        label="产品品类"
        prop="productCategory"
        v-if="productCategoryList.length > 0"
      >
        <DictSelect
          :disabled="status === 'update'"
          :propData="productCategoryList"
          :value="formData.productCategory"
          @change-emit="val=>formData.productCategory=val"
        />
      </el-form-item>
      <el-form-item label="主图片" class="img-box" id="img-box2" prop="mainImage">
        <UploadImage
          ref="uploadImage"
          :disabled="formDisabled"
          :status="status"
          :imgUrl="formData.mainImage"
          @img-change="mainImageChange"
        />
      </el-form-item>
      <el-form-item
        v-for="item in formList"
        :label="item.label"
        :key="item.label"
        :prop="item.value"
      >
        <el-radio-group v-model="formData[item.value]" v-if="item.tag === 'el-radio'">
          <el-radio
            v-for="op in item.propData"
            :key="op.code"
            :label="op.code"
          >{{op.label}}</el-radio>
        </el-radio-group>
        <component
          v-else
          :limitNum="item.limitNum"
          :maxlength="item.maxlength || 30"
          show-word-limit
          v-model="formData[item.value]"
          v-bind:is="item.tag"
          :propData="item.propData"
          :type="item.type"
          :value-format="item.valueFormat"
          :format="item.format"
          @change-emit="val=>formData[item.value]=val"
        ></component>
      </el-form-item>
      <el-form-item id="editor-box" label="产品详情" prop="productDetail">
        <TextareaEditor :disabled="formDisabled" ref="textareaEditor" />
        <ul class="OFFLINE-tips" v-if="formData.firstCategory === 'OFFLINE'">
          <li>每个版块、合作单位及花费情况</li>
          <li>物料品质、价格维度、供应商配合度、创意能力、供应商优劣势</li>
        </ul>
      </el-form-item>
      <el-form-item label="附件">
        <el-row class="fujian-box">
          <el-col :span="10" v-for="(item, index) in uploadBtns" :key="index">
            <UploadFile
              ref="uploadRef"
              :btnName="item.name"
              :field="item.field"
              :multiple="item.multiple"
              :maxSize="100"
              :excelFileExtend="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.jpeg'"
              :disabled="formDisabled"
              @file-list-change="arr => getFile(arr, item.field)"
            />
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <span style="margin: 20px 0 50px 300px" v-if="status === 'create' || status === 'update'">
      <el-button size="medium" :loading="saveLoading" @click="saveBtn" type="primary">保存草稿</el-button>
    </span>
    <!-- 审核 -->
    <div v-if="status === 'verify'">
      <el-divider class="cml-divider" content-position="center">
        {{ statusName }}意见
      </el-divider>
      <el-form
        :model="verifyFormData"
        :rules="verifyRules"
        ref="verifyFormData"
        label-width="300px"
      >
        <el-form-item label="审核结果" prop="auditStatus">
          <el-select
            v-model="verifyFormData.auditStatus"
            placeholder="请选择"
          >
            <el-option value="PASS" label="审核通过"></el-option>
            <el-option value="NO_PASS" label="审核不通过"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="verifyFormData.auditStatus === 'NO_PASS'"
          label="审核不通过原因"
          prop="auditOpinion"
        >
          <el-input v-model.trim="verifyFormData.auditOpinion" textarea></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button
          type="primary"
          size="medium"
          style="margin: 20px 0 50px 300px"
          :loading="saveLoading"
          @click="verifyBtn"
          >提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import DictSelect from '@/components/DictSelect';
import UploadImage from '@/components/Upload/UploadImage.vue';
import CustomNumInput from '@/components/CustomNumInput';
import TextareaEditor from '@/components/TextareaEditor';
import UploadFile from '@/components/Upload/UploadFile.vue';
import { FORM_LIST, FORM_MATCHUP, FILE_List, FIRST_TYPE_URL } from '@/utils/templateForm.js';

export default {
  name: 'publish-new-product',
  components: {
    SupplierSelect,
    DictSelect,
    UploadImage,
    CustomNumInput,
    TextareaEditor,
    UploadFile
  },
  data() {
    return {
      verifyRules: {
        auditStatus: [
          { required: true, message: '请选择审核结果', trigger: 'change' },
        ],
        auditOpinion: [
          { required: true, message: '请输入审核不通过原因', trigger: 'blur' },
        ],
      },
      verifyFormData: {
        auditOpinion: '',
        auditStatus: ''
      },
      formList: [],
      formData: {
        supplierCode: '',
        supplierName: '',
        productName: '',
        contactName: '',
        contactPhone: '',
        firstCategory: '',
        secondCategory: '',
        mainImage: '',
        specModel: '',
        totalPower: '',
        size: '',
        netWeight: '',
        deliveryDays: '',
        includeTaxPrice: '',
        taxRate: '',
        proxyFlag: '',
        miniOrderNum: '',
        payMethod: '',
        brand: '',
        material: '',
        parameters: '',
        responseTime: '',
        serviceContents: '',
        shortestServicePeriod: '',
        businessProcessTime: '',
        serviceContent: '',
        companyAddress: '',
        serviceClient: '',
        hasFrameworkAgreement: '',
        servicePeriod: '',
        sampleAmout: '',
        hasCnas: '',
        serviceCategory: '',
        serviceReadyPeriod: '',
        interviewVenueAddress: '',
        productDetail: '',
        productCategory: ''
      },
      productCategoryOptions: [],
      rules: {
        supplierCode: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        contactName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        productName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        firstCategory: [{ required: true, message: '请选择产品一级分类', trigger: 'change' }],
        secondCategory: [{ required: true, message: '请选择产品二级分类', trigger: 'change' }]
      },
      saveLoading: false,
      status: '',
      statusName: '',
      maxlength: 30,
      formDisabled: false,
      dialogVisible: false,
      uploadBtns: [],
      secondCategoryList: [],
      productCategoryList: [],
      isEditSupplier: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$route.query.id) {
        const { productId, status, statusName, type } = vm.$route.query;
        if (status === 'verify' || status === 'detail' ) {
          vm.formDisabled = true;
        } else {
          vm.formDisabled = false;
        }
        vm.status = status;
        vm.statusName = statusName;
        vm.getDetail(productId, type)
      } else {
        vm.resetForm();
      }
    });
  },
  mounted() {
    if (this.status === 'create') {
      const { user } = this.$store.getters.userSelf;
      this.formData.contactName = user.name;
      const { code, name, mobile } = this.$store.getters.userSupplier;
      if(code) {
        this.formData.supplierCode = code;
        this.formData.supplierName = name;
        this.formData.contactPhone = mobile || '13888888888';
      }
    }
    this.$http.pdLibrary.getCurrentUserConfig().then(result => {
      // 是否有权限编辑供应商 权限在产品审核配置中配置 配置了则可以编辑供应商 1、2为mushroom配置的管理员
      this.isEditSupplier = (result.data && result.data.loginName) || ['2', '1'].includes(this.$store.getters.userSelf.user.adminType)
    })
  },
  methods: {
    verifyBtn () {
      this.$refs.verifyFormData.validate(valid => {
        if(valid) {
          this.$http.pdLibrary.pdLibraryAudit({
            ...this.verifyFormData,
            id: this.$route.query.id
          }).then(result => {
            this.$message.success(result.msg);
            this.$store.dispatch('tagsView/jumpAndClosePage', {
              close: {
                name: this.$route.meta.title,
                href: this.$route.path,
              },
              open: {
                name: '审核产品',
                href: `/indirect-manage/audit-product`,
              },
            });
            this.$router.push({
              name: 'indirect-manage/audit-product',
              params: {
                status: this.status
              }
            });
          }).catch(err => {
            this.$message.error(err.msg);
          }).finally(() => {
            this.saveLoading = false;
          });
        }
      });
    },
    pageScrollToTop (id='cml-divider') {
      setTimeout(() => {
        document.querySelector(`#${id}`).scrollIntoView();
      }, 300)
    },
    getDetail (productId, type) {
      const url = FIRST_TYPE_URL[type];
      this.$http.pdLibrary[url + 'Get'](productId).then(result => {
        this.formData = {
          ...result.data,
          mainImage: result.data.mainImage || ''
        };
        this.$refs.textareaEditor.setHtml(result.data.productDetail);
        this.uploadBtns = FILE_List[FORM_MATCHUP[result.data.secondCategory]];
        this.formList = FORM_LIST[FORM_MATCHUP[result.data.secondCategory]];
        this.$nextTick(() => {
          this.$refs.uploadRef.map(item => {
            item.fileList = result.data[item.field].map((el) =>({
              fileName: el.name,
              fileUrl: el.url,
            }))
          });
        })
        this.$http.pdLibrary.listByFirstCategory(result.data.firstCategory).then((res) => {
          this.secondCategoryList = res.data.map(item => ({
            label: item.secondCategoryName,
            value: item.secondCategory
          }));
        })
      }).catch(err => {
        this.$message.error(err.msg);
      });
    },
    getFile (item, field) {
      this.formData[field] = item.map(item => ({
        name: item.fileName,
        url: item.fileUrl
      }))
    },
    supplierChange(val, name) {
      this.formData.supplierCode = val;
      this.formData.supplierName = name;
    },
    firstCategoryChange (val) {
      this.formData.secondCategory = '';
      this.formList = [];
      this.uploadBtns = [];
      this.formData.firstCategory = val;
      this.$http.pdLibrary.listByFirstCategory(val).then((res) => {
        this.secondCategoryList = res.data.map(item => ({
          label: item.secondCategoryName,
          value: item.secondCategory
        }));
      })
    },
    secondCategoryChange (val) {
      this.formData.secondCategory = val;
      this.productCategoryList = [];
      this.formData.productCategory = '';
      this.formList = FORM_LIST[FORM_MATCHUP[val]];
      this.uploadBtns = FILE_List[FORM_MATCHUP[val]];
      if (this.formData.firstCategory === 'MATERIAL') {
        const { gift_product_category } = this.$store.getters.allDictListData.data;
        this.productCategoryList = gift_product_category.filter(item => item.value.split('_')[0] === val);
      }
    },
    checkParams() {
      let state = true;
      if(!this.formData.mainImage) {
        this.$message.error('请选择主图片');
        state = false;
        return;
      }
      const { imgUrls, text } = this.$refs.textareaEditor.getHtml();
      if(imgUrls.length > 20) {
        this.$message.error('产品详情最多可以上传20张图片');
        state = false;
        return;
      }
      if(text.length > 5000) {
        this.$message.error('产品详情最多可以输入5000个字符');
        state = false;
        return;
      }
      return state;
    },
    saveBtn() {
      const { allHtml } = this.$refs.textareaEditor.getHtml();
      this.formData.productDetail = allHtml.trim();
      this.$refs.formData.validate(valid => {
        if(valid) {
          this.saveLoading = true;
          const url = FIRST_TYPE_URL[this.formData.firstCategory];
          const status = this.status === 'create' ? 'Create' : 'Update';
          this.$http.pdLibrary[`${url}${status}`](this.formData).then(result => {
            this.$message.success(result.msg);
            this.$store.dispatch('tagsView/jumpAndClosePage', {
              close: {
                name: this.$route.meta.title,
                href: this.$route.path,
              },
              open: {
                name: '产品列表',
                href: `/indirect-manage/product-list`,
              },
            });
            this.$router.push({
              name: 'indirect-manage/product-list',
              params: {
                status: this.status
              }
            });
          }).catch(err => {
            this.$message.error(err.msg);
          }).finally(() => {
            this.saveLoading = false;
          });
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          this.pageScrollToTop();
          return false;
        }
      });
    },
    resetForm() {
      this.status = 'create';
      this.statusName = '新增';
      this.row = { id: '' };
      this.$refs.formData.resetFields();
      Object.keys(this.formData).map(item => {
        this.formData[item] = undefined
      })
      this.uploadBtns = [];
      this.$refs.textareaEditor.clear();
      const { code, name } = this.$store.getters.userSupplier;
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    },
    mainImageChange(val) {
      this.formData.mainImage = val;
      if(val) {
        this.$refs.formData.clearValidate('mainImage');
      } else {
        this.$refs.formData.validateField('mainImage');
      }
    }
  },
};
</script>
<style lang="less">
.fujian-box {
  position: relative;
  width: 798px;
  height: 135px;
  & > div {
    margin: 0 10px 15px 0;
  }
  &::after {
    position: absolute;
    left: -125px;
    top: 30px;
    content: '（支持DOC、DOCX、PDF、XLS、XLSX、PPT、PPTX、JPG、PNG、JPEG格式文件）';
    width: 130px;
    font-size: 12px;
    line-height: 16px;
  }
}
#editor-box {
  position: relative;
}
.OFFLINE-tips {
  position: absolute;
  top: -10px;
  left: 832px;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
</style>